<div>
  <div
    *ngFor="let specialFacet of specialFacets"
    class="eb-product-variants-filter__special-facet-section"
  >
    <div
      [attr.special_facet_wrapper]="specialFacet.code"
      class="eb-product-variants-filter__special-facet-wrapper"
      [attr.data-cy]="'eb-special-facet-' + specialFacet.code"
      [class.eb-product-variants-filter__special-facet-wrapper__show-all]="specialFacetExpanded"
    >
      <div class="eb-product-variants-filter__special-facet-title">
        <h3>{{ getFacetTitle(specialFacet) | async }}</h3>
      </div>
      <div
        *ngFor="let item of specialFacet.items"
        class="eb-product-variants-filter__special-facet-box"
        [attr.data-cy]="'variant-filter'"
        (click)="
          applyFilter(specialFacet.code, item.code, specialFacet?.selectedValue?.code === item.code)
        "
        [class.selected]="specialFacet?.selectedValue?.code === item.code"
      >
        {{ item.text }}
        <cx-media
          *ngIf="specialFacet.images && specialFacet.images[item.code]"
          class="eb-product-variants-filter__facet-image"
          format="product"
          [container]="specialFacet.images[item.code]"
          [alt]="item.code"
        ></cx-media>
      </div>
    </div>
    <button
      *ngIf="shouldBeCollapsed(specialFacet.code)"
      class="eb-product-variants-filter__special-facet-box-show-more"
      (click)="toggleSpecialFacet()"
    >
      {{
        (specialFacetExpanded ? 'productVariant.showLess' : 'productVariant.showMore') | cxTranslate
      }}
    </button>
  </div>
  <div
    *ngIf="filterFacets?.length > 0"
    class="eb-product-variants-filter__technical-attribute-wrapper"
  >
    <eb-select-box
      *ngFor="let facet of filterFacets"
      [title]="getFacetTitle(facet) | async"
      [items]="facet.items"
      [selectedValue]="facet.selectedValue"
      [highlightSelectedValues]="true"
      (selection)="applyFilter(facet.code, $event.target.value)"
      placeholder="selectBox.placeholder"
      class="eb-product-variants-filter__technical-attribute"
    >
    </eb-select-box>
  </div>
</div>
<div
  *ngIf="facetService.isResetFiltersMessageVisible() | async"
  class="alert warning alert-warning"
>
  {{ 'productVariant.activeFiltersResetted' | cxTranslate }}
</div>

<div class="eb-product-variants-filter__filtered-results">
  {{
    numberOfResults === 1
      ? ('productVariant.singleSearchResult' | cxTranslate)
      : ('productVariant.searchResult' | cxTranslate: { numberOfResults: numberOfResults || 0 })
  }}
  <ng-container *ngIf="freeTextSearch">
    {{ 'productVariant.freeTextSearch' | cxTranslate }}
    <span class="eb-product-variants-filter__free-text-search"> {{ freeTextSearch }}</span>
    <button
      (click)="resetSearch()"
      class="eb-product-variants-filter__delete-free-text-search-button"
    >
      <em class="fas fa-times"></em>
    </button>
  </ng-container>
</div>
